import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=43d0a505"
import script from "./Language.js?vue&type=script&lang=js&external"
export * from "./Language.js?vue&type=script&lang=js&external"
import style0 from "./Language.vue?vue&type=style&index=0&id=43d0a505&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports